export const translations = {
  es: {
    // Sidebar
    "menu_start": "Empieza aquí",
    "menu_desktop": "Escritorio",
    "menu_guides": "Guías",
    "menu_history": "Historial",
    "menu_creations": "Mis Creaciones",
    "menu_tools": "Herramientas IA",
    "menu_image": "Generación de imagen",
    "menu_avatar": "Vídeos con Avatar",
    "menu_video": "Generación de vídeo",
    "menu_templates": "Plantillas de vídeo",
    "promo_title": "Ahorra un <span class=\"gradient-text\">50% Ahora</span>",
    "promo_coupon": "Cupón: <strong>EMPIEZA50</strong>",
    "promo_btn": "Suscríbete",
    
    // Topbar
    "topbar_subscribe": "Suscríbete",
    "topbar_sub_detail": " para obtener acceso completo",
    "topbar_help": "Ayuda",
    
    // Help Modal
    "help_title": "¿Necesitas ayuda?",
    "help_sub": "¿Tienes dudas o algo no funciona como esperabas? Cuéntanos y te respondemos enseguida.",
    "help_name": "Tu nombre",
    "help_email": "Tu email",
    "help_msg_label": "¿En qué podemos ayudarte?",
    "help_msg_placeholder": "Describe tu duda o problema...",
    "help_send": "Enviar mensaje",
    "help_direct": "O escríbenos directamente a",
    
    // Dashboard (Escritorio)
    "dashboard_welcome": "Bienvenido de nuevo",
    "dashboard_sub": "Comienza a crear contenido con IA hoy",
    "dashboard_hero_title": "Bienvenido a <span class=\"gradient-text\">Vimo</span>",
    "dashboard_hero_desc": "Crea imágenes, vídeos y avatares con los mejores modelos de IA. Empieza desde una herramienta o explora tus creaciones recientes.",
    "dashboard_quick": "Creación rápida",
    "dashboard_quick_desc": "Describe lo que quieres crear y la IA se encargará del resto.",
    "dashboard_recent": "Tus creaciones recientes",
    "dashboard_see_all": "Ver todo",
    "dashboard_see_all_link": "Ver todas <i class=\"bi bi-arrow-right\"></i>",
    "dashboard_credits": "Créditos disponibles",
    "dashboard_usage": "Consumo mensual",
    "dashboard_usage_detail": "Detalle de uso",
    "tool_image_desc": "Crea imágenes desde un prompt o usa una imagen de referencia.",
    "tool_avatar_desc": "Crea vídeos con avatares hablantes o diseña tu propio personaje con IA.",
    "tool_video_desc": "Crea vídeos cinematográficos con imagen inicial y final.",
    "tool_templates_desc": "Empieza con plantillas profesionales y ahorra tiempo.",
    
    // History
    "history_title": "Historial",
    "history_sub": "Retoma cualquier sesión donde la dejaste",
    "history_search": "Buscar por prompt o nombre de sesión...",
    "history_all": "Todo",
    "history_filter_image": "Imagen",
    "history_filter_video": "Vídeo",
    "history_filter_avatar": "Avatar",
    "history_filter_template": "Plantilla",
    
    // My Creations
    "creations_title": "Mis Creaciones",
    "creations_sub": "Tu colección personal",
    "creations_empty_title": "No tienes creaciones",
    "creations_empty_desc": "Las imágenes, vídeos o avatares que generes aparecerán aquí.",
    "creations_preview_title": "<i class=\"bi bi-eye\" style=\"color: #6366f1;\"></i> Vista Previa de Recurso",
    "creations_preview_prompt": "<i class=\"bi bi-text-left\"></i> Contenido y Prompt de Generación:",
    
    // Guides
    "guides_title": "Guías de aprendizaje",
    "guides_sub": "Aprende a sacar el máximo partido a Vimo",
    
    // Profile
    "profile_title": "Mi Perfil",
    "profile_sub": "Gestiona tu cuenta y suscripción",
    "profile_save": "Guardar cambios",
    "profile_logout": "Cerrar sesión",
    "profile_info": "Información Personal",
    "profile_name_label": "Nombre",
    "profile_name_placeholder": "Tu nombre",
    "profile_lastname_label": "Apellido",
    "profile_lastname_placeholder": "Tu apellido",
    "profile_email_label": "Dirección de correo",
    "profile_phone_label": "Teléfono",
    "profile_phone_opt": "(opcional)",
    "profile_sub_label": "Mi suscripción",
    "profile_cancel_sub": "Cancelar suscripción",
    "profile_plan_label": "Plan actual",
    "profile_status_label": "Estado de la cuenta",
    "profile_security": "Seguridad",
    "profile_curr_pass": "Contraseña actual",
    "profile_new_pass": "Nueva contraseña",
    "profile_conf_pass": "Confirmar contraseña",
    "profile_change_pass": "Cambiar contraseña",
    "profile_cancel_title": "¿Cancelar suscripción?",
    "profile_cancel_desc": "Perderás el acceso a las funciones Premium al final del periodo de facturación actual. Podrás volver a suscribirte cuando quieras.",
    "profile_cancel_keep": "Mantener suscripción",
    "profile_cancel_confirm": "Sí, cancelar",
    "help_name_placeholder": "Tu nombre"
  },
  en: {
    // Sidebar
    "menu_start": "Start here",
    "menu_desktop": "Dashboard",
    "menu_guides": "Guides",
    "menu_history": "History",
    "menu_creations": "My Creations",
    "menu_tools": "AI Tools",
    "menu_image": "Image Generation",
    "menu_avatar": "Avatar Videos",
    "menu_video": "Video Generation",
    "menu_templates": "Video Templates",
    "promo_title": "Save <span class=\"gradient-text\">50% Now</span>",
    "promo_coupon": "Coupon: <strong>START50</strong>",
    "promo_btn": "Upgrade to Premium",
    
    // Topbar
    "topbar_subscribe": "Subscribe",
    "topbar_sub_detail": " to get full access",
    "topbar_help": "Help",
    
    // Help Modal
    "help_title": "Need help?",
    "help_sub": "Have doubts or something is not working as expected? Tell us and we will answer you quickly.",
    "help_name": "Your name",
    "help_email": "Your email",
    "help_msg_label": "How can we help you?",
    "help_msg_placeholder": "Describe your doubt or problem...",
    "help_send": "Send message",
    "help_direct": "Or write to us directly at",
    
    // Dashboard (Escritorio)
    "dashboard_welcome": "Welcome back",
    "dashboard_sub": "Start creating content with AI today",
    "dashboard_hero_title": "Welcome to <span class=\"gradient-text\">Vimo</span>",
    "dashboard_hero_desc": "Create images, videos and avatars with the best AI models. Start from a tool or explore your recent creations.",
    "dashboard_quick": "Quick creation",
    "dashboard_quick_desc": "Describe what you want to create and the AI will take care of the rest.",
    "dashboard_recent": "Your recent creations",
    "dashboard_see_all": "See all",
    "dashboard_see_all_link": "See all <i class=\"bi bi-arrow-right\"></i>",
    "dashboard_credits": "Available credits",
    "dashboard_usage": "Monthly consumption",
    "dashboard_usage_detail": "Usage detail",
    "tool_image_desc": "Create images from a prompt or use a reference image.",
    "tool_avatar_desc": "Create talking avatar videos or design your own character with AI.",
    "tool_video_desc": "Create cinematic videos with starting and ending frames.",
    "tool_templates_desc": "Get started with professional templates and save time.",
    
    // History
    "history_title": "History",
    "history_sub": "Resume any session where you left off",
    "history_search": "Search by prompt or session name...",
    "history_all": "All",
    "history_filter_image": "Image",
    "history_filter_video": "Video",
    "history_filter_avatar": "Avatar",
    "history_filter_template": "Template",
    
    // My Creations
    "creations_title": "My Creations",
    "creations_sub": "Your personal collection",
    "creations_empty_title": "You have no creations",
    "creations_empty_desc": "Images, videos or avatars you generate will appear here.",
    "creations_preview_title": "<i class=\"bi bi-eye\" style=\"color: #6366f1;\"></i> Resource Preview",
    "creations_preview_prompt": "<i class=\"bi bi-text-left\"></i> Generation Content & Prompt:",
    
    // Guides
    "guides_title": "Learning Guides",
    "guides_sub": "Learn to make the most of Vimo",
    
    // Profile
    "profile_title": "My Profile",
    "profile_sub": "Manage your account and subscription",
    "profile_save": "Save changes",
    "profile_logout": "Log out",
    "profile_info": "Personal Information",
    "profile_name_label": "First Name",
    "profile_name_placeholder": "Your name",
    "profile_lastname_label": "Last Name",
    "profile_lastname_placeholder": "Your last name",
    "profile_email_label": "Email address",
    "profile_phone_label": "Phone",
    "profile_phone_opt": "(optional)",
    "profile_sub_label": "My subscription",
    "profile_cancel_sub": "Cancel subscription",
    "profile_plan_label": "Current plan",
    "profile_status_label": "Account status",
    "profile_security": "Security",
    "profile_curr_pass": "Current password",
    "profile_new_pass": "New password",
    "profile_conf_pass": "Confirm password",
    "profile_change_pass": "Change password",
    "profile_cancel_title": "Cancel subscription?",
    "profile_cancel_desc": "You will lose access to Premium features at the end of the current billing period. You can resubscribe anytime.",
    "profile_cancel_keep": "Keep subscription",
    "profile_cancel_confirm": "Yes, cancel",
    "help_name_placeholder": "Your name"
  },
  pt: {
    // Sidebar
    "menu_start": "Comece aqui",
    "menu_desktop": "Painel",
    "menu_guides": "Guias",
    "menu_history": "Histórico",
    "menu_creations": "Minhas Criações",
    "menu_tools": "Ferramentas IA",
    "menu_image": "Geração de imagem",
    "menu_avatar": "Vídeos com Avatar",
    "menu_video": "Geração de vídeo",
    "menu_templates": "Modelos de vídeo",
    "promo_title": "Economize <span class=\"gradient-text\">50% Agora</span>",
    "promo_coupon": "Cupom: <strong>COMECA50</strong>",
    "promo_btn": "Atualizar para Premium",
    
    // Topbar
    "topbar_subscribe": "Inscreva-se",
    "topbar_sub_detail": " para obter acesso total",
    "topbar_help": "Ajuda",
    
    // Help Modal
    "help_title": "Precisa de ajuda?",
    "help_sub": "Tem dúvidas ou algo não funciona como esperado? Diga-nos e responderemos rapidamente.",
    "help_name": "Seu nome",
    "help_email": "Seu email",
    "help_msg_label": "Como podemos te ajudar?",
    "help_msg_placeholder": "Descreva sua dúvida ou problema...",
    "help_send": "Enviar mensagem",
    "help_direct": "Ou escreva-nos diretamente para",
    
    // Dashboard (Escritorio)
    "dashboard_welcome": "Bem-vindo de volta",
    "dashboard_sub": "Comece a criar conteúdo com IA hoje",
    "dashboard_hero_title": "Bem-vindo ao <span class=\"gradient-text\">Vimo</span>",
    "dashboard_hero_desc": "Crie imagens, vídeos e avatares com os melhores modelos de IA. Comece com uma ferramenta ou explore suas criações recentes.",
    "dashboard_quick": "Criação rápida",
    "dashboard_quick_desc": "Descreva o que deseja criar e a IA cuidará do resto.",
    "dashboard_recent": "Suas criações recentes",
    "dashboard_see_all": "Ver tudo",
    "dashboard_see_all_link": "Ver todas <i class=\"bi bi-arrow-right\"></i>",
    "dashboard_credits": "Créditos disponíveis",
    "dashboard_usage": "Consumo mensal",
    "dashboard_usage_detail": "Detalhes de uso",
    "tool_image_desc": "Crie imagens a partir de um prompt ou use uma imagem de referência.",
    "tool_avatar_desc": "Crie vídeos com avatares falantes ou crie seu próprio personagem com IA.",
    "tool_video_desc": "Crie vídeos cinematográficos com quadros iniciais e finais.",
    "tool_templates_desc": "Comece com modelos profissionais e economize tempo.",
    
    // History
    "history_title": "Histórico",
    "history_sub": "Retome qualquer sessão de onde parou",
    "history_search": "Buscar por prompt ou nome da sessão...",
    "history_all": "Tudo",
    "history_filter_image": "Imagem",
    "history_filter_video": "Vídeo",
    "history_filter_avatar": "Avatar",
    "history_filter_template": "Modelo",
    
    // My Creations
    "creations_title": "Minhas Criações",
    "creations_sub": "Sua coleção pessoal",
    "creations_empty_title": "Você não tem criações",
    "creations_empty_desc": "As imagens, vídeos ou avatares que você gerar aparecerão aqui.",
    "creations_preview_title": "<i class=\"bi bi-eye\" style=\"color: #6366f1;\"></i> Visualização de Recurso",
    "creations_preview_prompt": "<i class=\"bi bi-text-left\"></i> Conteúdo e Prompt de Geração:",
    
    // Guides
    "guides_title": "Guias de Aprendizagem",
    "guides_sub": "Aprenda a tirar o máximo proveito do Vimo",
    
    // Profile
    "profile_title": "Meu Perfil",
    "profile_sub": "Gerencie sua conta e assinatura",
    "profile_save": "Salvar alterações",
    "profile_logout": "Sair",
    "profile_info": "Informações Pessoais",
    "profile_name_label": "Nome",
    "profile_name_placeholder": "Seu nome",
    "profile_lastname_label": "Sobrenome",
    "profile_lastname_placeholder": "Seu sobrenome",
    "profile_email_label": "Endereço de e-mail",
    "profile_phone_label": "Telefone",
    "profile_phone_opt": "(opcional)",
    "profile_sub_label": "Minha assinatura",
    "profile_cancel_sub": "Cancelar assinatura",
    "profile_plan_label": "Plano atual",
    "profile_status_label": "Status da conta",
    "profile_security": "Segurança",
    "profile_curr_pass": "Senha atual",
    "profile_new_pass": "Nova senha",
    "profile_conf_pass": "Confirmar senha",
    "profile_change_pass": "Alterar senha",
    "profile_cancel_title": "Cancelar assinatura?",
    "profile_cancel_desc": "Você perderá o acesso aos recursos Premium no final do período de faturamento atual. Você poderá assinar novamente a qualquer momento.",
    "profile_cancel_keep": "Manter assinatura",
    "profile_cancel_confirm": "Sim, cancelar",
    "help_name_placeholder": "Seu nome"
  }
};
